var render, staticRenderFns
import script from "./DesignTimeSupport.vue?vue&type=script&lang=js&"
export * from "./DesignTimeSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab77ac2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab77ac2')) {
      api.createRecord('0ab77ac2', component.options)
    } else {
      api.reload('0ab77ac2', component.options)
    }
    
  }
}
component.options.__file = "src/pages/featureOnePage/base/DesignTimeSupport.vue"
export default component.exports